import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LangContext";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const { t } = useLang();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error(t("Les mots de passe ne correspondent pas.", "Passwords do not match."));
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message);
      nav("/espace-client");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-[148px] min-h-screen" data-testid="reset-password-page">
      <section className="max-w-md mx-auto px-5 py-16 md:py-24">
        <Reveal>
          <p className="overline mb-4 flex items-center gap-2" style={{ color: "var(--orange)" }}><KeyRound size={15} /> {t("Sécurité", "Security")}</p>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight leading-none mb-8">{t("Nouveau mot de passe.", "New password.")}</h1>
        </Reveal>
        {!token ? (
          <p style={{ color: "var(--ink-2)" }}>
            {t("Lien invalide. ", "Invalid link. ")}
            <Link to="/espace-client" className="font-semibold underline" style={{ color: "var(--orange)" }}>{t("Refaire une demande", "Request again")}</Link>
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4 p-8" style={{ background: "var(--white)", border: "1px solid var(--border)" }} data-testid="reset-password-form">
            <input className="field" type="password" required minLength={8} placeholder={t("Nouveau mot de passe (8 car. min.) *", "New password (min. 8 chars) *")}
              value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
            <input className="field" type="password" required minLength={8} placeholder={t("Confirmer le mot de passe *", "Confirm password *")}
              value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
            <button type="submit" disabled={loading} className="btn-primary w-full py-4 font-semibold flex items-center justify-center gap-2" data-testid="reset-submit-btn">
              {loading ? <Loader2 size={17} className="animate-spin" /> : t("Mettre à jour mon mot de passe", "Update my password")}
            </button>
          </form>
        )}
      </section>
    </div>
  );
}
